import { render, staticRenderFns } from "./DashboardScenarioView.vue?vue&type=template&id=1267a28b&scoped=true&"
import script from "./DashboardScenarioView.vue?vue&type=script&lang=js&"
export * from "./DashboardScenarioView.vue?vue&type=script&lang=js&"
import style0 from "./DashboardScenarioView.vue?vue&type=style&index=0&id=1267a28b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1267a28b",
  null
  
)

/* custom blocks */
import block0 from "./DashboardScenarioView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports